// Auto-import all feature routes
// Using require.context for Vue CLI compatibility (instead of import.meta.glob)
const routeContext = require.context('../features', true, /routes\/.*\.routes\.js$/)

const featureRoutes = routeContext.keys()
  .map(key => routeContext(key).default)
  .flat()
  .filter(Boolean)

console.log('[Router] Registered feature routes:', featureRoutes.length)

export { featureRoutes }

